import { GET_ORDER_CHARGES } from '../actionTypes/OrderActionTypes';

export const getOrderCharges = (payload) => ({
    type: GET_ORDER_CHARGES,
    payload,
});

export default getOrderCharges;
